import {
  PayPalScriptProvider,
  usePayPalScriptReducer,
  type SCRIPT_LOADING_STATE,
} from '@paypal/react-paypal-js';
import {
  useEffect,
  type FunctionComponent,
  type PropsWithChildren,
} from 'react';

import { PAYPAL_OPTIONS } from './constants';
import { Paypal4xLabelContent } from './Paypal4xLabelContent';

interface Paypal4xLabelProps {
  className?: string;
  amount?: number;
}

const DelayedPaypalContent: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [, dispatch] = usePayPalScriptReducer();

  useEffect(() => {
    const onPageLoad = () => {
      dispatch({
        type: 'setLoadingStatus',
        value: 'pending' as SCRIPT_LOADING_STATE.PENDING,
      });
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, [dispatch]);

  return children;
};

export const Paypal4xLabel: FunctionComponent<Paypal4xLabelProps> = ({
  className,
  amount,
}) => (
  <PayPalScriptProvider options={PAYPAL_OPTIONS} deferLoading>
    <DelayedPaypalContent>
      <Paypal4xLabelContent className={className} amount={amount} />
    </DelayedPaypalContent>
  </PayPalScriptProvider>
);
